import styled from 'styled-components';

export const FieldRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

export const FieldLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 0 0 260px;
    padding: 5px 0;
    line-height: 22px;
    color: var(--gray-9);
`;

export const FieldControl = styled.div`
    flex: 1;
    min-width: 0;
`;
